import KenColors from './KenColors';
export const typography = {
    fontFamily: [
        'lato',
        'sans-serif',
    ].join(','),
    body2: {
        fontSize: '12px',
        lineHeight: 1,
        color: KenColors.neutral400
    },
    subtitle2: {
        fontSize: '12px',
        lineHeight: 1
    }
};